export const gasAppPanelStyles = (theme) => ({
  wrapper: {
    padding: 15,
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    boxShadow: '0 4px 9px 0 rgba(0, 0, 0, 0.02)',
  },
})
